import React from "react";

export const EyeOpenIcon = ({
  props,
  height,
  width,
}: {
  props?: React.SVGProps<SVGSVGElement>;
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "16"}
      height={height || "12"}
      viewBox="0 0 16 12"
      fill="none"
      {...props}
    >
      <path
        d="M7.77246 0C9.51845 0.000124845 11.0947 0.834531 12.3447 1.80566C13.6012 2.78186 14.586 3.94164 15.1611 4.69238C15.6714 5.35851 15.6714 6.26649 15.1611 6.93262C14.586 7.68336 13.6012 8.84314 12.3447 9.81934C11.0947 10.7905 9.51845 11.6249 7.77246 11.625C6.02626 11.625 4.44933 10.7906 3.19922 9.81934C1.94275 8.84314 0.957961 7.68336 0.382812 6.93262C-0.127397 6.26653 -0.127397 5.35847 0.382812 4.69238C0.957961 3.94164 1.94275 2.78186 3.19922 1.80566C4.44933 0.834419 6.02626 0 7.77246 0ZM7.77246 1.125C6.38239 1.125 5.0469 1.79524 3.88965 2.69434C2.73873 3.58852 1.8201 4.66497 1.27539 5.37598C1.07432 5.63843 1.07432 5.98657 1.27539 6.24902C1.8201 6.96003 2.73873 8.03648 3.88965 8.93066C5.0469 9.82976 6.38239 10.5 7.77246 10.5C9.16234 10.4999 10.4972 9.82963 11.6543 8.93066C12.8052 8.03651 13.7238 6.96004 14.2686 6.24902C14.4696 5.98657 14.4696 5.63843 14.2686 5.37598C13.7238 4.66496 12.8052 3.58849 11.6543 2.69434C10.4972 1.79537 9.16234 1.12513 7.77246 1.125ZM7.77246 3C9.32572 3.00004 10.585 4.25923 10.585 5.8125C10.585 7.36577 9.32572 8.62496 7.77246 8.625C6.21916 8.625 4.95996 7.3658 4.95996 5.8125C4.95996 4.2592 6.21916 3 7.77246 3ZM7.77246 4.125C6.84048 4.125 6.08496 4.88052 6.08496 5.8125C6.08496 6.74448 6.84048 7.5 7.77246 7.5C8.7044 7.49996 9.45996 6.74445 9.45996 5.8125C9.45996 4.88055 8.7044 4.12504 7.77246 4.125Z"
        fill="#31394A"
      />
    </svg>
  );
};
